import { action, observable } from 'mobx';
import { toast } from "react-toastify";
import FirebaseCustomerService from "../services/impl/firebase/FirebaseCustomerService";
import ICustomerService from "../services/spi/ICustomerService";
import ICustomer, { newCustInstance, ICustomerCollection, ICustomerFilter, newCustFilterInstance, validateCust, isCustValid } from "../types/ICustomer";
import { setValueNestedObj } from './utility.js';
import IPaginator, { IPaginatorQueryType, newPaginatorInstance } from '../types/Paginator';
import IListService from '../services/spi/IListService';
import FirebaseListService from '../services/impl/firebase/FirebaseListService';
import IList, { IListItem } from '../types/IList';
import * as ROUTES from '../constants/routes';
import { IActivityCollection } from '../types/IActivity';



class CustomerStore {
  rootStore:any = null;
  customerService = {} as ICustomerService;
  listService = {} as IListService;
  @observable customer:ICustomer = newCustInstance();
  @observable customers = [] as Array<ICustomer>;
  @observable customerActivities: IActivityCollection= {
    activities: [],
    paginator: newPaginatorInstance(10)
  }
  @observable screen = {
    list: {
      isLoading: false
    },
    create: {
      isUploading: false,
      uploadingPercent: 20,
      isSaving: false
    },
    edit: {
      isLoading: false,
      isUploading: false,
      isSaving: false,
    },
    editMode: false,
    createMode: false,
    viewMode: false
  }

  @observable errors:any = {};

  @observable customerCollection:ICustomerCollection = {
    customers: [],
    paginator: newPaginatorInstance()
  };
  @observable activitiesList = [] as Array<IListItem>;
  @observable timelineList = [] as Array<IListItem>;
  @observable customerFilter = {} as ICustomerFilter;
  @observable customerPaginator = {} as IPaginator;
  @observable activeTab: number = 1;

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.customerService = new FirebaseCustomerService();
    this.listService = new FirebaseListService();
    this.customerFilter = newCustFilterInstance();
    this.customerPaginator = newPaginatorInstance();
  } 

  @action setCustomerFilter(filter?:Partial<ICustomerFilter>, added?:boolean){
   this.customerFilter = {...this.customerFilter, ...filter};
   this.customerPaginator = newPaginatorInstance();
  }

  @action setPaginator(paginator:Partial<IPaginator>){
    this.customerPaginator = Object.assign(this.customerPaginator, paginator);
  }

  @action loadCustomers = async () => {
      try{
        this.screen.list.isLoading = true; 
        this.customerCollection = await this.customerService.getCustomers(this.customerPaginator, this.customerFilter);
        this.customerPaginator = this.customerCollection.paginator;
        this.screen.list.isLoading = false;
      }catch(e){
        this.screen.list.isLoading = false;
        toast.error("Error loading customers. ");
      }
  }

  @action loadSideBarFilterData = async () => {
    try{
      const activitiesList:IList = await this.listService.getList("CUSTOMER_ACTIVITIES");
      this.activitiesList = activitiesList.options;
      const timelineList:IList = await this.listService.getList("CUSTOMER_TIMELINE");
      this.timelineList = timelineList.options;
    }catch(e){
      debugger
      toast.error("Couldnot load filter data");
    }
  }

  @action changeScreenState = (obj:any) => {
    this.screen = {...this.screen, ...obj};
    this.errors = {};
  }

  @action createNewRow = (cust: ICustomer) => {
      this.customer = newCustInstance();
  }

  @action loadCustomer = async (uid:string) => {
    try{
      this.screen.edit.isLoading = true;
      if(uid == null || uid == undefined ){
        this.customer = newCustInstance();
      } else {
        this.customer = await this.customerService.getCustomer(uid);
        this.customerActivities = await this.customerService.getCustomerActivities(uid, newPaginatorInstance(10))
      }
      this.screen.edit.isLoading = false
    }catch(e){
      this.screen.edit.isLoading = false;
      toast.error('Error Loading Customer');
      this.customer = newCustInstance();
      this.customerActivities = {
        activities: [],
        paginator: newPaginatorInstance(20)
      }
    }
    
  }

  @action revalidateCustomer = async () => {
    this.errors = await validateCust(this.customer);
  }

  @action toggleTab = (index: number) => {
    this.activeTab = index;
  }

  @action setAttribute = (attrPath: string, attrValue: string) =>{
    setValueNestedObj(attrPath, attrValue, this.customer);
    this.revalidateCustomer()
  }

  @action setBooleanAttribute = (attrPath: string, attrValue: boolean) => {
    setValueNestedObj(attrPath, attrValue, this.customer);
    this.revalidateCustomer()
  }

  @action saveImage = (value: string) => {
    this.customer.account.image = value;
  }

  @action saveCustomer = async (history:any) => {
    const { uid } = this.customer;
    try {
      if(await isCustValid(this.customer)){
        if (uid == undefined || uid == '') {
          await this.customerService.createCustomer(this.customer);
          toast.success("Customer Created");
        } else {
          await this.customerService.updateCustomer(this.customer);
          toast.success("Customer Updated!!");
        }
        history.push(ROUTES.CUSTOMER);
      } else {
        this.revalidateCustomer();
      }
    }catch (ex) {
      toast.error("Customer Create Failed. Try Again Later!");
    }
  }


  @action deleteCustomer = async (uid: string) => {
    try{
      if(this.customer.uid){
        let res = await this.customerService.deleteCustomer(this.customer.uid);
        if(res){
          toast.success('Customer Info Deleted')
        }
      }
    }catch(e){
      toast.error("Error Deleting customer");
    }
  }

}

export default CustomerStore;